import React, { useState, useEffect, useRef, useCallback } from 'react';
import AnimatedContent from "../Common/AnimatedContent";
import 'animate.css';
import { ImExit } from "react-icons/im";
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

const Helpyou = () => {
    const howcosworks = useRef(null);
    const cardRefs = useRef([]);
    const [visibleCards, setVisibleCards] = useState([]);

    useEffect(() => {
        if (window.location.hash === '#howcosworks') {
            howcosworks.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const observerCallback = useCallback((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setVisibleCards((prev) => [...new Set([...prev, index])]);
            }
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(observerCallback, { threshold: 0.2 });

        cardRefs.current.forEach((card, index) => {
            if (card) observer.observe(card);
        });

        return () => observer.disconnect();
    }, [observerCallback]);

    const textVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
        }),
    };

    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const text = "How CoOwnSpace Works";
    const characters = text.split("");

    const cardData = [
        {
            icon: "icon-search",
            title: "Explore Investment Opportunities",
            description:
                "Browse our diverse collection of investment opportunities. From vacant plots and farmland to scenic vacation homes and lucrative commercial properties, CoOwnSpace provides access to a variety of real estate that fits your investment strategy.",
        },
        {
            icon: "icon-house-1",
            title: "Invest in a Fraction",
            description:
                "Instead of buying an entire property, you invest in a fraction of it. Each fraction represents a share of ownership, making real estate investment more affordable for everyone.",
        },
        {
            icon: "icon-money",
            title: "Earn Returns",
            description:
                "Enjoy rental income and long-term appreciation proportional to your investment. CoOwnSpace ensures efficient property management for hassle-free returns.",
        },
        {
            icon: <ImExit />,
            title: "Seamless Exit Options",
            description:
                "When you're ready to liquidate, CoOwnSpace offers flexible exit strategies, allowing you to sell your share to other investors through our platform or explore other options.",
        },
    ];

    return (
        <section ref={howcosworks} id='howcosworks' className="section-help tf-spacing-1 ">
            <div className="tf-container">
                <div className="row">
                    <div className="col-12">
                        <div className="heading-section text-center">
                            <h2 ref={ref} className="title balance text-h2 ">
                                {characters.map((char, i) => (
                                    <motion.span
                                        key={i}
                                        className="inline-block "
                                        variants={textVariants}
                                        initial="hidden"
                                        animate={inView ? "visible" : "hidden"}
                                        custom={i}
                                    >
                                        {char}
                                    </motion.span>
                                ))}
                            </h2>
                            <AnimatedContent
                                distance={5}
                                direction="vertical"
                                reverse={false}
                                config={{ tension: 80, friction: 20 }}
                                initialOpacity={0.2}
                                animateOpacity
                                scale={1.1}
                                threshold={0.2}
                            >
                                <p className="text-1 animate__fadeInUp animate__animated">
                                    We simplify real estate investment by offering fractional ownership across a wide range of properties.
                                </p>
                            </AnimatedContent>
                        </div>

                        <div className="tf-grid-layout md-col-2 mb-6">
                            {cardData.map((card, index) => (
                                <div
                                    key={index}
                                    ref={(el) => (cardRefs.current[index] = el)}
                                    className={`icons-box style-3 icon-direction ${
                                        visibleCards.includes(index) ? "animate__animated animate__zoomIn" : ""
                                    }`}
                                >
                                    <div className="tf-icon">
                                        {typeof card.icon === "string" ? <i className={card.icon}></i> : card.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title text-h3">{card.title}</h3>
                                        <p className="text-0">{card.description}</p>
                                        {/* <a href="" className="tf-btn-link color-3">
                                         <span>Learn More</span>
                                        </a> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="item text-center p-5">
            </div>
        </section>
    );
};

export default Helpyou;
